<button class="mm-button">
    <ng-content></ng-content>
</button>
